module.exports = __webpack_public_path__ + "static/media/loading-transparent.01856242.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading-transparent.svg
// module id = 700
// module chunks = 0